/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

module.exports = [{
  action: 'updateCustomerRunnerTicketSchemeEntriesByRootId',
  message: messages.SUCCESS_UPDATE_CUSTOMER_RUNNER_TICKET_SCHEME_ENTRIES_BY_ROOT_ID,
  method: 'PATCH',
  path: '/customer/:customerId/runner-ticket-scheme-entries/:rootId',
  payloadType: 'collection',
  permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_RUNNER_TICKET_SCHEME_ENTRY,
  requestSchema: requestSchemas.customerRunnerTicketSchemeEntries.updateCustomerRunnerTicketSchemeEntriesByRootId,
}];
